import { useState } from 'react';
import useGetNotifications from '../notifications/dashboardNotifications/useGetNotifications';
import useGetTotalApplicationsCount from '../jobs/useGetTotalApplicationsCount';
import useGetInitialFeedbackPrompt from '../../prompts/useGetInitialFeedbackPrompt';
import useGetMonthlyFeedbackPrompt from '../../prompts/useGetMonthlyFeedbackPrompt';
import { useAppSelector } from '../../../redux/store';
import useGetInvitedJobs from '../jobs/invite/useGetInvitedJobs';

const useMiniLoad = () => {
  const { authData } = useAppSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);

  const { getNotifications } = useGetNotifications();
  const { getTotalApplicationsCount } = useGetTotalApplicationsCount();
  const { getInitialFeedbackPrompt } = useGetInitialFeedbackPrompt();
  const { getMonthlyFeedbackPrompt } = useGetMonthlyFeedbackPrompt();
  const { getInvitedJobs } = useGetInvitedJobs();

  const getMiniLoadData = () => {
    setLoading(true);

    if (authData?.id) {
      Promise.all([
        getNotifications(),
        getTotalApplicationsCount(),
        getInitialFeedbackPrompt(),
        getMonthlyFeedbackPrompt(),
        getInvitedJobs(),
      ])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  return { getMiniLoadData, loading };
};

export default useMiniLoad;
